export default __webpack_public_path__ + "static/media/head_banner_tap.2d3703f3.webp";